import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getBrandList(params) { // 获取品牌列表
    return axios.post(global.MSI_PPRODUCT + '/trademark/findAllProductTradeMark', params)
  }
}


// WEBPACK FOOTER //
// ./src/request/pmc/brand.js